import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable, of } from 'rxjs'

import { getUrlParams } from '~/utils/index'

import {
  IEdgarQueueStatisticAiDto,
  IEdgarStatisticAiDto,
  IEdgarSummaryAiDto,
  IResponsePaginationApiDto,
  ISearchPaginationData,
} from '../models'

const FORECAST_PREFIX = 'forecast'
const EDGAR_PREFIX = 'edgar'

@Injectable({
  providedIn: 'any',
})
export class ForecastEdgarApiService {
  constructor(private http: HttpClient) {}

  getForecastEdgarReportSummary(ticker: string): Observable<IEdgarSummaryAiDto> {
    return this.http.get<IEdgarSummaryAiDto>(`${FORECAST_PREFIX}/${EDGAR_PREFIX}/${ticker}/summary`)
  }

  parseForecastEdgarReport(ticker: string): Observable<IEdgarSummaryAiDto> {
    return this.http.get<IEdgarSummaryAiDto>(`${FORECAST_PREFIX}/${EDGAR_PREFIX}/${ticker}/summary/parse`)
  }

  getForecastEdgar(isCompanyPage: boolean, ticker: string): Observable<any> {
    return this.http.get(`${FORECAST_PREFIX}/${EDGAR_PREFIX}/${ticker}?isCompanyPage=${isCompanyPage}`, {
      responseType: 'text',
    })

    return of('TMP')
    // return this.http.get<string>(`assets/document.html`, {
    //   headers: {
    //     conte,
    //   },
    // })
  }

  initBatchApi(ticker: string): Observable<IEdgarSummaryAiDto> {
    return this.http.get<IEdgarSummaryAiDto>(`${FORECAST_PREFIX}/${EDGAR_PREFIX}/${ticker}/init-batch-api`)
  }

  getActiveBatches(searchData: ISearchPaginationData): Observable<IResponsePaginationApiDto<IEdgarSummaryAiDto>> {
    const data = {
      search: '',
      sortBy: searchData.sortBy,
      order: searchData.order,
      page: searchData.paginatorData.page,
      perPage: searchData.paginatorData.perPage,
      filters: searchData.filters,
    }

    const urlParams = getUrlParams(data)

    return this.http.get<IResponsePaginationApiDto<IEdgarSummaryAiDto>>(
      `${FORECAST_PREFIX}/${EDGAR_PREFIX}/active-batch/list?${urlParams}`
    )
  }

  getBatchStatistics(filters: { [key: string]: any }): Observable<IEdgarStatisticAiDto> {
    const urlParams = getUrlParams({ filters })

    return this.http.get<IEdgarStatisticAiDto>(
      `${FORECAST_PREFIX}/${EDGAR_PREFIX}/active-batch/statistics?${urlParams}`
    )
  }

  getBatchQueueStatistics(): Observable<IEdgarQueueStatisticAiDto> {
    return this.http.get<IEdgarQueueStatisticAiDto>(`${FORECAST_PREFIX}/${EDGAR_PREFIX}/active-batch/queue-statistics`)
  }

  checkBatchStatus(batchId: string): Observable<IEdgarSummaryAiDto[]> {
    return this.http.get<IEdgarSummaryAiDto[]>(`${FORECAST_PREFIX}/${EDGAR_PREFIX}/check-batch-status/${batchId}`)
  }

  getButchResult(outputFileId: string): Observable<any> {
    return this.http.get<any>(`${FORECAST_PREFIX}/${EDGAR_PREFIX}/get-batch-result/${outputFileId}`)
  }
}
